import { ACCORDION } from "./accordion";
import { ASSORTMENTS } from "./assortments";
import { ASSORTMENTS_MANAGEMENT } from "./assortments-management";
import { BUYER_DASHBOARD } from "./buyer-dashboard";
import { CAMPAIGNS } from "./campaigns";
import { GALLERY } from "./gallery";
import { MEDIA } from "./media";
import { INTERNAL_NOTES } from "./internal-notes";
import { LIFECYCLE_SCRIPTS } from "./lifecycle-scripts";
import { LOGIN } from "./login";
import { MANAGE_CONNECTIONS } from "./manage-connections";
import { MIN_MAX } from "./min-max";
import { NAV } from "./navigation";
import { HEADER_NOTIFICATIONS } from "./header-notifications";
import { CANCELLED_STYLES } from "./cancelled-styles";
import { ORDER_SPLIT } from "./order-splitting";
import { ORDER_RECAP } from "./order-recap";
import { PREFERRED_RETAILERS } from "./preferred-retailers";
import { MERCHANT_INVENTORY_SETTINGS } from "./merchant-inventory-settings";
import { PAGES } from "./pages";
import { PROFILE } from "./profile";
import { SHIPPING_PROMOTIONS } from "./shipping-promotions";
import { SHIPPING_MANAGEMENT } from "./shipping-management";
import { SHIPMENT_REVIEW } from "./shipment-review";
import { SMART_GROUPS } from "./smart-groups";
import { WAREHOUSES } from "./warehouses";
import { WHITEBOARDS } from "./whiteboards";
import { ORDER_SETTINGS } from "./order-settings";
import { WORKING_ORDER } from "./working-order";
import { INVENTORY_SETTINGS } from "./inventory_settings";
import { ORDERS } from "./orders";
import { ORDER_INTENTS } from "./order-intents";
import { BRAND_SETTINGS } from "./brand-settings";
import { ADMIN_SETTINGS } from "./admin-settings";
import { COLOR_PICKER } from "./color-picker";
import { WATERMARKING } from "./watermarking";
import { CUSTOMER_USER_GROUPS } from "./customer-user-groups";
import { BARCODE_MANAGEMENT } from "./barcode-management";
import { OTS } from "./online-trade-show";
import { CATALOG } from "./catalog";
import { SITE_HEADER } from "./site-header";
import { VIEW_AS_PANEL } from "./view-as-panel";
import { CONTACTS } from "./contacts";
import { FOLDERS, FOLDER_IDENTIFIERS } from "./folders";
import { INVENTORY_DATA } from "./inventory-data";
import { PAYMENTS_DASHBOARD } from "./payments-dashboard";
import { SITES } from "./sites";
import { GATEWAYS } from "./gateways";
import { IMAGE_SETTINGS } from "./image-settings";
import { PDP } from "./pdp";
import { MANAGE_CREDIT_CARDS, MANAGE_PAYMENT_METHODS } from "./manage-credit-cards";
import { WARNING_DIALOG } from "./warning-dialog";
import { SIZE_PACKS } from "./size-packs";
import { REAL_TIME_PRICING } from "./real-time-pricing";
import { BRAND_INFO } from "./brand_info";
import { ATS_EXPORTS } from "./ats-exports";
import { EXPORT_TEMPLATES } from "./export-templates";
import { MERCHANT_ADMIN_ACCOUNT } from "./merchant-admin-account";
import { MERCHANT_ADMIN_MEMBER_LIST } from "./merchant-admin-member-list";
import { MERCHANT_ADMIN_MEMBER_DETAILS } from "./merchant-admin-member-details";
import { MERCHANT_ADMIN_SETTINGS } from "./merchant-admin-settings";
import { CARD_DETAILS, PAYMENTS_POPUP, PAYMENTS_PREFERENCES, PAYMENT_METHODS } from "./payments";
import { PRODUCT_IMAGES_UPLOAD } from "./product-images-upload";
import { MERCHANTS_APP } from "./merchants-app";
import { CUSTOMIZATIONS } from "./customizations";
import { ROLLUP } from "./rollup";
import { PROMOTIONS } from "./promotions";
import { PRICING } from "./pricing";
import { BUILD_ORDER } from "./build-order";
import { CHALLENGE } from "./challenge";
import { PRODUCTS_DATA_UPLOAD } from "./products-data-upload";
import { AUDIT } from "./audit";
import { PRICESHEETS_DATA_UPLOAD } from "./pricesheets-data-upload";
import { BUYERS_DATA_UPLOAD } from "./buyers-data-upload";
import { COMPANIES_DATA_UPLOAD } from "./companies-data-upload";
import { INVENTORY_DATA_UPLOAD } from "./inventory-data-upload";
import { EOTPOS } from "./export-order-to-pos";
import { ATOMIC_COMPONENTS } from "./atomic-components";
import { ADMIN_PERMISSIONS } from "./admin-permissions";
import { BUYER_MANAGE_STORE } from "./buyer-manage-store";
import { PAYMENT_CONFIGURATIONS } from "./payment-configurations";
import { MANAGE_DISTRIBUTION } from "./manage-distribution";
import { CUSTOM_MAPPING } from "./dataflow";
import { GRID_VIEW } from "./grid-view";
import { SIZE_CURVE_IMPORT } from "./size-curve-import";
import { MANAGE_PAYMENT_PROCESSING } from "./manage-payment-processing";
import { FUNDTHROUGH } from "./fundthrough";
import { PRODUCT_VISIBILITY_REPORT } from "./product-visibility-report";
import { RETAILER_PROFILE } from "./retailer-profile";
import { MERCHANT_MANAGEMENT } from "./merchant-management";
import { BULK_MANAGER } from "./bulk-manager";
import { INSIGHTS } from "./insights";

export const DATATEST = {
    ACCORDION,
    ASSORTMENTS,
    PROMOTIONS,
    PRICING,
    BUILD_ORDER,
    BULK_MANAGER,
    REAL_TIME_PRICING,
    ASSORTMENTS_MANAGEMENT,
    ATS_EXPORTS,
    CAMPAIGNS,
    GALLERY,
    MEDIA,
    INTERNAL_NOTES,
    LIFECYCLE_SCRIPTS,
    LOGIN,
    MANAGE_CREDIT_CARDS,
    MANAGE_PAYMENT_METHODS,
    MIN_MAX,
    MANAGE_CONNECTIONS,
    NAV,
    HEADER_NOTIFICATIONS,
    CANCELLED_STYLES,
    ORDER_SPLIT,
    ORDER_RECAP,
    PAGES,
    PREFERRED_RETAILERS,
    PROFILE,
    SIZE_PACKS,
    SHIPPING_PROMOTIONS,
    SHIPPING_MANAGEMENT,
    SHIPMENT_REVIEW,
    SMART_GROUPS,
    WAREHOUSES,
    WHITEBOARDS,
    BUYER_DASHBOARD,
    ORDER_SETTINGS,
    ORDERS,
    ORDER_INTENTS,
    OTS,
    WORKING_ORDER,
    CATALOG,
    INVENTORY_SETTINGS,
    INVENTORY_DATA,
    BRAND_SETTINGS,
    ADMIN_SETTINGS,
    CUSTOMER_USER_GROUPS,
    BARCODE_MANAGEMENT,
    SITE_HEADER,
    VIEW_AS_PANEL,
    CONTACTS,
    PAYMENTS_DASHBOARD,
    SITES,
    GATEWAYS,
    IMAGE_SETTINGS,
    WARNING_DIALOG,
    MERCHANT_INVENTORY_SETTINGS,
    BRAND_INFO,
    EXPORT_TEMPLATES,
    MERCHANT_ADMIN_ACCOUNT,
    MERCHANT_ADMIN_MEMBER_LIST,
    MERCHANT_ADMIN_MEMBER_DETAILS,
    MERCHANT_ADMIN_SETTINGS,
    CARD_DETAILS,
    PAYMENTS_POPUP,
    PAYMENTS_PREFERENCES,
    PAYMENT_METHODS,
    PRODUCT_IMAGES_UPLOAD,
    PRODUCTS_DATA_UPLOAD,
    PRICESHEETS_DATA_UPLOAD,
    BUYERS_DATA_UPLOAD,
    COMPANIES_DATA_UPLOAD,
    INVENTORY_DATA_UPLOAD,
    CUSTOMIZATIONS,
    BUYER_MANAGE_STORE,
    CUSTOM_MAPPING,
    GRID_VIEW,
    SIZE_CURVE_IMPORT,
    MANAGE_PAYMENT_PROCESSING,
    FUNDTHROUGH,

    CART_NOTIFICATIONS: {
        ALERTS: {
            ROOT: "cart-notifications-alerts-root",
            ERROR: "cart-notifications-alerts-error-count",
            INFO: "cart-notifications-alerts-info-count",
            WARNING: "cart-notifications-alerts-warning-count",
            SUCCESS: "cart-notifications-alerts-success-count",
        },
    },

    CALENDAR_CANCEL_BUTTON: "calendar-cancel-button",
    TITLE_INPUT: "title-input",
    CUSTOMERPO_INPUT: "customer_po",
    NUORDER_SHIMMER_LOADER: "nuorder-shimmer-loader",
    MARKET_PLACE: "marketplace",
    CLEAR_INPUT: "clear-input",
    CLEAR_FILTERS: "clear-filters",

    FILTERS_SIDEBAR: "filters-sidebar",
    NOTIFICATION_BANNER: {
        ROOT: "notification-banners-root",
        ERROR: "notification-banners-error",
        INFO: "notification-banners-info",
        WARNING: "notification-banners-warning",
        SUCCESS: "notification-banners-success",
        ORDERING: "notification-banners-ordering",
    },
    NOTIFICATIONS_BTN: "notifications-btn",
    NOTIFICATIONS_CONTAINER: "notifications-container",
    NOTIFICATION_CONTENT: "notifications-content",
    NOTIFCATIONS_CONTAINER_TITLE: "notifications-container-title",
    NOTIFICATION_CLOSE_BTN: "notifications-close-btn",
    NUORDER_LOGO_BTN: "nuorder-btn",
    NUORDER_HAMBURGER_MENU: "nuorder-hamburger-menu",
    DIALOG: {
        CONTAINER: "siteDialog",
        CANCEL: "cancel",
        CONFIRM: "confirm",
        CLOSE: "close",
        APPLY: "apply",
    },

    LINEAR_PROGRESS: {
        LABEL: "label",
    },

    PLAYER_3D: {
        PROCESSING_CONTAINER: "processing-container",
        PLAYER: "player-3d",
        THREEDIUM_CONTAINER: "threedium-container",
        THREEDIUM_IFRAME: "threedium-iframe",
        HINT: "hint",
    },

    EDIT_DELIVERY: {
        PRODUCT_NAME: "edit-delivery-product-name",
        DELIVERY_RANGE: "edit-delivery-delivery-range",
    },
    DELIVERY_MANAGEMENT: {
        TABLE: {
            ROOT: "delivery-management-table-root",
            ROW: "delivery-management-table-row",
            ROW_ACTIONS: {
                EDIT: "delivery-management-table-row-edit",
                DELETE: "delivery-management-table-row-delete",
            },
        },
        ADD_DELIVERY: {
            ROOT: "delivery-management-add-root",
            LABEL: "delivery-management-add-label",
            DELIVERY_SOURCE: "delivery-management-source",
            ORDER_DELIVERIES_SELECT: "existing-deliveries-select",
            NEW_DELIVERIES_SELECT: "new-deliveries-select",
            WAREHOUSE_SELECT: "add-delivery-warehouse-select",
            SHIP_START: "ship-start",
            SHIP_END: "ship-end",
            ACTIONS_CONTAINER: "actions-container",
        },
        DISCARD_CONFIRMATION: {
            LABEL: "discard-confirmation-label",
            CONTENT: "discard-confirmation-content",
        },
        DELETE_CONFIRMATION: {
            LABEL: "delete-confirmation-label",
            CONTENT: "delete-confirmation-content",
        },
        INVENTORY_ARRIVING: {
            LABEL: "inventory-arriving-label",
            WAREHOUSE_SELECT: "inventory-arriving-warehouse-select",
        },
    },

    EXCEEDED_QUANTITIES: {
        MODAL: {
            LABEL: "exceeded-quantities-label",
            CONTENT: "exceeded-quantities-content",
        },
    },

    PRODUCT_INVENTORY: {
        INVENTORY_ARRIVING_TABLE: "inventory-arriving-table",
        UNITS_SOURCE: "units_source",
        TOTAL_UNITS_FILTER: "total-units-filter",
        UNITS_ARRIVING_FILTER: "units-arriving-filter",
        UNITS_HINT: "units-hint",
    },

    MEDIA_DIALOG: {
        DIALOG_TITLE: "dialog-title",
        CLOSE_BTN: "close-btn",
        SAVE_BTN: "save-btn",
        DELETE_BTN: "delete-btn",
        IMAGES_360_UPLOADER: "images-360-uploader",
        IMAGES_360_SPECIFICATIONS: "images-360-specs",
        VIDEO_UPLOADER: "video-uploader",
        VIDEO_SPECIFICATIONS: "video-specs",
        IMAGE_UPLOADER: "images-uploader",
        IMAGE_SPECIFICATIONS: "images-specs",
        THREEDIUM_UPLOADER: "threedium-uploader",
        THREEDIUM_SPECIFICATIONS: "threedium-specs",
        THREEDIUM_SPECIFICATIONS_LINK: "threedium-specs-link",
        UPLOAD_ERROR_CONTAINER: "upload-error-container",
    },

    ALERT: {
        DISMISS: "dismiss",
    },
    POPUP: {
        POPUP_DISMISS: "popup-dismiss-btn",
        POPUP_CONFIRM: "popup-confirm-btn",
    },
    ADMIN_SECTION: "admin-link-section",
    BRAND_PICKER: "brand-picker",
    BRAND_SEARCH: "brand-search",
    ACTIVE_BRAND: "active-brand",
    BRAND_LIST: "brand-list",
    NOT_CONNECTED_TO_ANY_BRAND: "not-connected-to-any-brand",
    SHOW_DISABLED_BRANDS_TOGGLE: {
        ENABLED: "show-disabled-brand-enabled",
        DISABLED: "show-disabled-brand-disabled",
    },

    REQUEST_BRAND_ACCESS: {
        CONNECT_WITH_THIS_BRAND: "connect-with-this-brand",
        PRODUCT_INFO: "request-reason-product-info",
        ORDER: "request-reason-order",
        FOLLOW_UP: "request-reason-follow-up",
        BRAND_INFO: "request-reason-brand-info",
        MESSAGE: "request-reason-optional-message",
        CONNECT_WITH_MORE: "connect-with-more-brands-confirm",
        DISMISS: "connect-with-more-brands-cancel",
    },

    MODAL_PROMPT_CONFIRM: "modal-prompt-confirm",
    MODAL_PROMPT_CANCEL: "modal-prompt-cancel",

    MODAL_PROMT_TEXT: "modal-promt-text",
    MODAL_PROMPT_INPUT: "modal-prompt-input",

    UTLITIES: {
        INFO: "info",
        USER_INFORMATION_LOOKUP: "user-information-lookup",
        ACTIVE_STATUS_LOOKUP: "active-status-lookup",
        CLONE: "clone",
        DATAFLOW: "dataflow",
        RETAILERS_LIST: "retailers-list",
        RETAILERS_ENTRY_FORM: "retailers-entry-form",
        EMAIL_LOGS: "email-logs",
        LINK_BUYERS: "link-buyers",
        MANAGE_USERS: "manage-users",
        ASSORTMENTS_MANAGEMENT: "assortments-management",
        ASSORTMENTS_MANAGEMENT_SUPERUSERS: "assortments-management-superusers",
        MERCHANTS_MANAGEMENT: "merchants-management",
        ASSORTMENTS_SUPPORT: "assortments-support",
        ASSORTMENTS_SUPPORT_INPUT: "assortments-support-input",
        ASSORTMENTS_SUPPORT_ITEM_SELECTOR: "assortments-support-item-selector",
        ACCOUNT_MANAGERS: "account-managers",
        PARENT_COMPANY: "parent-company",
        PRODUCT_SIZE_OVERRIDES: "product-size-overrides",
    },

    ACTIVE_STATUS_LOOKUP: {
        PAGE: "active-status-lookup",
        INPUT_ID: "active-status-lookup-input-id",
        INPUT_TYPE: "input-type",
        STATUS_TYPE: "status-type",
        STATUS_TYPES: {
            SHOW_ALL: "show-all",
            SHOW_ACTIVE: "show-active",
            SHOW_INACTIVE: "show-inactive",
        },
        DURATION: {
            START: "active-status-duration-start",
            END: "active-status-duration-end",
        },
        TYPES: {
            USER: "option-user",
            COMPANY: "option-company",
            BRAND: "option-brand",
        },
        SEARCH_BUTTON: "active-status-lookup-search",
        GENERAL_INFORMATION: "general-information",
        FIELDS: {
            NAME: "active-status-subject-name",
            EMAIL: "active-status-subject-email",
            TYPE: "active-status-subject-type",
            ACCOUNT_TYPE: "active-status-subject-account-type",
            ACCOUNT_STATUS: "active-status-subject-account-status",
        },
        ACTIVE_STATUSES: "active-statuses",
        PAGINATION: {
            PREV: "active-status-pagination-prev",
            NEXT: "active-status-pagination-next",
        },
        PERCENTAGE_STAT: "active-status-percentage-stat",
        TABLE: "active-status-table",
    },

    USER_INFORMATION_LOOKUP: {
        PAGE: "user-information-lookup",
        EMAIL_INPUT: "lookup-email-input",
        SEARCH_BUTTON: "lookup-email-search",
        GENERAL_INFORMATION: "lookup-general-information",
        FIELDS: {
            EMAIL: "lookup-email",
            NAME: "lookup-name",
            ACCOUNT_TYPE: "lookup-account-type",
            ACCOUNT_GROUP: "lookup-account-group",
            ACCOUNT_STATUS: "lookup-account-status",
            LAST_LOGIN: "lookup-last-login",
            LEADERSHIP: "lookup-leadership",
            BRANDS: "lookup-brands",
            MARKETPLACE_CONNECTIONS: "lookup-marketplace-connections",
            RETAILER_CONNECTIONS: "lookup-retailer-connections",
            REQUESTED_CONNECTIONS: "lookup-requested-connections",
            IMPERSONATIONS: "lookup-impersonations",
            STATUS_HISTORY_REASON: "lookup-status-history-reason",
            STATUS_HISTORY_ACTOR: "lookup-status-history-actor",
        },
        PAGINATION: {
            IMPERSONATIONS: {
                PREV: "lookup-impersonations-prev",
                NEXT: "lookup-impersonations-next",
            },
            MARKETPLACE_CONNECTIONS: {
                PREV: "lookup-marketplace-connections-prev",
                NEXT: "lookup-marketplace-connections-next",
            },
            RETAILER_CONNECTIONS: {
                PREV: "lookup-retailer-connections-prev",
                NEXT: "lookup-retailer-connections-next",
            },
            BRANDS: {
                PREV: "lookup-brands-prev",
                NEXT: "lookup-brands-next",
            },
        },
    },

    SELECT_FIELD_ERROR: "select-field-error",
    TILE_CARD: "tile-card",

    ADD_TO_ORDER: "add-to-order",
    REMOVE_FROM_ORDER: "remove-from-order",
    ITEM_TILE: "item-tile",
    CURRENCY_BREAKDOWN: {
        GRID: "currency-breakdown-grid",
        WHOLESALE: "wholesale-",
        RETAIL: "retail-",
    },
    ITEMS_GRID: "items-grid",
    PRODUCT: {
        STYLE_NUMBER: "style_number",
        PRICES: {
            ORIGINAL_WHOLESALE: "product-original-wholesale-price",
            WHOLESALE: "product-wholesale-price",
            MSRP: "product-msrp-price",
            DISCOUNTED: "product-discounted-price",
            DISCOUNTED_STICKY: "product-discount-price-sticky",
        },
        SELECTED: {
            TRASH_ICON: "trash-icon",
            IMAGE: "image",
            NAME: "name",
        },
        DETAILS: "product-details",
        IMPORTANT_INFO: "product-important-info",
        PANEL: {
            CLOSE_BTN: "product-panel-close-btn",
        },
    },

    TOOLBAR: {
        GRID_VIEW: "grid-btn",
        TILE_VIEW: "tile-view-btn",
    },
    TOOL_PANEL: {
        DOORS: {
            METRICS: {
                METRICS_LIST: "tool-panel-doors-metrics-list",
                HEADER: "tool-panel-doors-metrics-metric-header",
                SWITCH: "tool-panel-doors-metrics-metric-switch",
                TOTAL_SWITCH: "tool-panel-doors-metrics-metric-total-switch",
                PLAN_SWITCH: "tool-panel-doors-metrics-metric-plan-switch",
            },
            APPLY_BTN: "tool-panel-doors-apply",
        },
    },
    SAVE_BTN: "save-btn",
    CANCEL_BTN: "cancel-btn",
    SORT_BTN: "sort-btn",
    FOLDERS,
    DOORS_BY_PRODUCT: "doors-by-product",
    STYLES_BY_DOOR: "styles-by-door",
    HOVER_LISTENER: "hover-listener",

    TOTAL_LABEL: "total_label",
    LOADING_SPINNER: "loading-spinner",
    INLINE_LOADING: "inline-loading",
    LOADING_CONTACTS_SPINNER: "loading-contacts-spinner",
    PDP,
    SNACKBAR_MESSAGE: "snackbar-message",
    SNACKBAR_LATEST: "snackbar-latest",
    SNACKBAR_OLD_VERSION: "snackbar-old-version",
    SNACKBAR_CLOSE: "snackbar-close",
    APPLIED_PROMOTIONS_MESSAGE: "applied-promotions-message",
    SNACKBAR_LOADER: "snackbar-loader",
    DYNAMIC_FIELDS: {
        CONTAINER: "dynamic-fields-container",
        LEFT_LIST: "left-list",
        LIST_ITEM: "list-item",
        RIGHT_LIST: "right-list",
        TYPE_LIST: "type-list",
        REMOVE_ICON: "remove-icon",
    },
    SNACKBAR_VIEW_CART: "snackbar-view-cart",
    SNACKBAR_UNDO: "snackbar-view-cart",
    SNACKBAR_CUSTOM_ACTIONS: {
        INSIGHTS_ADD: "insights-add-action",
    },

    ACCESS_CONTROL_ERROR_MODAL_BODY: "access-control-error-modal-body",
    MERCHANTS_APP,
    ROLLUP,

    ORDER: {
        TOTAL_AMOUNT: "order-total-amount",
    },

    PRICING_SERVICE_PROMOTIONS: {
        PROMOTION_MODAL: {
            MODAL: "pricing-service-promotion-modal",
            NAME: "pricing-service-promotion-modal-name",
            DESCRIPTION: "pricing-service-promotion-modal-description",
            CANCEL: "pricing-service-promotion-modal-cancel",
        },
    },
    PAGE_NOT_FOUND: {
        NOT_FOUND: "not-found",
    },
    LIGHTSPEED_REPORT: {
        REPORT_IFRAME: "report-iframe",
    },
    COLOR_PICKER,
    WATERMARKING,
    DEFAULT_ALLOCATION_DIMENSION_PREFERENCES: {
        SAVE_BUTTON: "data-save-button",
        RESET_BUTTON: "data-reset-button",
    },
    DEFAULT_SHARED_SETTINGS: {
        SAVE_BUTTON: "default-shared-setting__save-button",
        RESET_BUTTON: "default-shared-setting__data-reset-button",
    },
    CHALLENGE,
    AUDIT,
    EOTPOS,
    ATOMIC_COMPONENTS,
    ADMIN_PERMISSIONS,
    SEARCH_TYPE_MODAL_DIALOG_EXPANDED_TEXT: "Expanded search",
    SEARCH_TYPE_MODAL_DIALOG_EXPANDED_ENABLE_TEXT: "is enabled",
    SEARCH_TYPE_EXPANDED: "expanded",
    SEARCH_TYPE_STANDARD: "standard",
    SEARCH_TYPE_MODAL_DIALOG_ID: "SearchSettings",
    SEARCH_SETTINGS: {
        OPEN_MODAL_ICON: "search-settings-open-modal-icon",
        MODAL: {
            CONFIRM: "search-settings",
            CANCEL: "cancel",
            INFO_ICON: "search-type-modal-dialog-icon-button",
            RADIO_STANDARD: "search-settings-modal-standard",
            RADIO_EXPANDED: "search-settings-modal-expanded",
        },
    },
    PAYMENT_CONFIGURATIONS,
    MANAGE_DISTRIBUTION,
    MANAGEMENT_ALLOCATION_DIMENSION: {
        TEXT_DESCRIPTION: "management-allocation-dimension__text-description",
        ROW_COLUMN: {
            CANCEL: "management-allocation-dimension__row-column__cancel",
            SAVE: "management-allocation-dimension__row-column__save",
        },
        ROW_ADD: "management-allocation-dimension__row__add",
        COLUMN_ADD: "management-allocation-dimension__column__add",
    },
    SMART_ORDERS: {
        MODAL: {
            DISMISS: {
                ROOT: "smart-orders_modal_dismiss_root",
                CONTENT: "smart-orders_modal_dismiss_content",
            },
            REPLACE_CART: {
                ROOT: "smart-orders_modal_replace-cart_root",
                CONTENT: "smart-orders_modal_replace-cart_content",
            },
        },
    },
    PRODUCT_VISIBILITY_REPORT,
    RETAILER_PROFILE,
    MERCHANT_MANAGEMENT,
    INSIGHTS,
    MERCHANT_SETTINGS: {
        TEMPLATE: {
            NAME: "merchant-settings__template",
        },
        GENERAL_PAGE: {
            NAME: "merchant-settings__general-page",
        },
        STORE_PROFILE_PAGE: {
            NAME: "merchant-settings__store-profile-page",
        },
    },
};

// UNIQUE IDENTIFIERS
export const DATA_IDS = {
    FOLDERS: FOLDER_IDENTIFIERS,
    ACCORDION_OPEN_BTN: "accordion-open-btn",
};
